module.exports = __webpack_public_path__ + "ca201a04e71a692f6ef47bfef7bf7604.png";